// extracted by mini-css-extract-plugin
export default {"warningText":"styles_warningText__dBuCf","description":"styles_description__xiKgt"};